import { useState } from "react";
import { Form, Input, Row, Col, Button, message, InputNumber } from "antd";
import useRoleAccess from "@/hooks/useRoleAccess";
import axios from "axios";

export default function InputPerhitunganKredit({
  application_id,
  nik,

  jenisAngsur,
  setJenisAngsur,
  metodeBunga,
  setMetodeBunga,
  maskapaiAsuransi,
  setMaskapaiAsuransi,

  harga,
  setHarga,
  uangMukaAmount,
  setUangMukaAmount,
  uangMukaPercent,
  setUangMukaPercent,

  pokokHutang,
  setPokokHutang,
  tenor,
  setTenor,
  gracePeriod,
  setGracePeriod,

  bungaFlat,
  setBungaFlat,
  bungaEfektif,
  setBungaEfektif,
  nilaiAngsuran,
  setNilaiAngsuran,

  pencairanKeDealer,
  setPencairanKeDealer,
  tanggalCair,
  setTanggalCair,
  metodeAngsur,
  setMetodeAngsur,

  pembayaran,
  setPembayaran,
  rateDenda,
  setRateDenda,
  penalty,
  setPenalty,

  loading,
  setLoading,
  onSaveSuccess,
  data,
}) {
  const { isViewer } = useRoleAccess();
  const initialData = data?.[0]?.data?.perhitaungan_kredit || [];
  console.log("initialData perhitaungan_kredit ==>", initialData);

  const formatRupiah = (value) => {
    if (!value) return "";
    const number = value.toString().replace(/\D/g, "");
    return new Intl.NumberFormat("id-ID").format(number);
  };

  const parseRupiah = (value) => {
    if (!value) return "";
    return value.toString().replace(/\D/g, "");
  };

  const [isEdit, setIsEdit] = useState(initialData == null ? true : false);

  const disabled = !isEdit || loading;

  const handleCancel = () => {
    if (!initialData) return;

    // reset semua field ke data awal
    setJenisAngsur(initialData.jenis_angsur || "");
    setMetodeBunga(initialData.metode_bunga || "");
    setMaskapaiAsuransi(initialData.maskapai_asuransi || "");
    setHarga(initialData.harga_kendaraan || "");
    setUangMukaAmount(initialData.uang_muka || "");
    setUangMukaPercent(initialData.uang_muka_percent || 0);
    setPokokHutang(initialData.pokok_hutang || "");
    setTenor(initialData.tenor || 0);
    setGracePeriod(initialData.grace_period || 0);
    setBungaFlat(initialData.bunga_flat || 0);
    setBungaEfektif(initialData.bunga_efektif || 0);
    setNilaiAngsuran(initialData.nilai_angsuran || "");
    setPencairanKeDealer(initialData.pencairan_ke_dealer || "");
    setTanggalCair(initialData.tanggal_cair || "");
    setMetodeAngsur(initialData.metode_angsur || "");
    setPembayaran(initialData.pembayaran || "");
    setRateDenda(initialData.rate_denda || 0);
    setPenalty(initialData.penalty || 0);

    setIsEdit(false);
  };

  const handleSave = async () => {
    const payload = {
      application_id: application_id,
      nik: nik,
      harga_kendaraan: parseRupiah(harga),
      uang_muka: parseRupiah(uangMukaAmount),
      pokok_hutang: parseRupiah(pokokHutang),
      nilai_angsuran: parseRupiah(nilaiAngsuran),
      pencairan_ke_dealer: parseRupiah(pencairanKeDealer),
      jenis_angsur: jenisAngsur,
      metode_bunga: metodeBunga,
      maskapai_asuransi: maskapaiAsuransi,
      uang_muka_percent: uangMukaPercent,
      tenor,
      grace_period: gracePeriod,
      bunga_flat: bungaFlat,
      bunga_efektif: bungaEfektif,
      tanggal_cair: tanggalCair,
      metode_angsur: metodeAngsur,
      pembayaran,
      rate_denda: rateDenda,
      penalty,
    };

    try {
      setLoading(true);

      console.log("Payloadd ==>> ", payload);

      // await axios.post("https://api.domain.com/perhitungan-kredit", payload);
      await axios.put(
        `${API_BASE_URL2}/api/createhitungankredit/${application_id}/${nik}`,
        payload,
      );

      message.success("Data perhitungan kredit berhasil disimpan");

      // if (onSaveSuccess) onSaveSuccess(); // contoh: getData()
      onSaveSuccess?.();
    } catch (error) {
      console.error(error);
      message.error("Gagal menyimpan data perhitungan kredit");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
      <Form layout="vertical">
        {/* ROW 1 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Jenis Angsur">
              <Input
                value={jenisAngsur}
                onChange={(e) => setJenisAngsur(e.target.value)}
                disabled={disabled}
                placeholder="Contoh: Bulanan / Mingguan / Jatuh Tempo"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Metode Bunga">
              <Input
                value={metodeBunga}
                onChange={(e) => setMetodeBunga(e.target.value)}
                disabled={disabled}
                placeholder="Contoh: Flat / Efektif"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Maskapai Asuransi">
              <Input
                value={maskapaiAsuransi}
                onChange={(e) => setMaskapaiAsuransi(e.target.value)}
                disabled={disabled}
                placeholder="Nama maskapai"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ROW 2 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Harga Kendaraan (Rp)">
              <Input
                prefix="Rp"
                value={formatRupiah(harga)}
                onChange={(e) => setHarga(parseRupiah(e.target.value))}
                disabled={disabled}
                placeholder="Masukkan harga kendaraan"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Uang Muka (Rp)">
              <Input
                prefix="Rp"
                value={formatRupiah(uangMukaAmount)}
                onChange={(e) => setUangMukaAmount(parseRupiah(e.target.value))}
                disabled={disabled}
                placeholder="Rp"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Uang Muka (%)">
              <InputNumber
                className="w-full"
                min={0}
                max={100}
                value={uangMukaPercent}
                disabled={disabled}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                onChange={(value) => setUangMukaPercent(value)}
                placeholder="0 - 100"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ROW 3 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Pokok Hutang (Manual)">
              <Input
                prefix="Rp"
                value={formatRupiah(pokokHutang)}
                onChange={(e) => setPokokHutang(parseRupiah(e.target.value))}
                disabled={disabled}
                placeholder="Masukkan pokok hutang"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Tenor (bulan)">
              <InputNumber
                className="w-full"
                min={0}
                value={tenor}
                onChange={(value) => setTenor(value)}
                disabled={disabled}
                placeholder="Contoh: 36"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Grace Period (bulan)">
              <InputNumber
                className="w-full"
                min={0}
                value={gracePeriod}
                onChange={(value) => setGracePeriod(value)}
                disabled={disabled}
                placeholder="0 / 1 / 2 ..."
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ROW 4 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Bunga Flat (% per tahun)">
              {/* <Input
                value={bungaFlat}
                onChange={(e) => setBungaFlat(e.target.value)}
                disabled={disabled}
                placeholder="Jika metode Flat"
              /> */}
              <InputNumber
                className="w-full"
                min={0}
                max={100}
                value={bungaFlat}
                disabled={disabled}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                onChange={(value) => setBungaFlat(value)}
                placeholder="0 - 100"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Bunga Efektif (% per tahun)">
              {/* <Input
                value={bungaEfektif}
                onChange={(e) => setBungaEfektif(e.target.value)}
                disabled={disabled}
                placeholder="Jika metode Efektif"
              /> */}
              <InputNumber
                className="w-full"
                min={0}
                max={100}
                value={bungaEfektif}
                disabled={disabled}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                onChange={(value) => setBungaEfektif(value)}
                placeholder="0 - 100"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Nilai Angsuran (Manual)">
              <Input
                prefix="Rp"
                value={formatRupiah(nilaiAngsuran)}
                onChange={(e) => setNilaiAngsuran(parseRupiah(e.target.value))}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ROW 5 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Pencairan ke Dealer (MIBAS)">
              <Input
                prefix="Rp"
                value={formatRupiah(pencairanKeDealer)}
                onChange={(e) =>
                  setPencairanKeDealer(parseRupiah(e.target.value))
                }
                disabled={disabled}
                placeholder="Masukkan pencairan ke dealer"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Tanggal Cair">
              <Input
                type="date"
                value={tanggalCair}
                onChange={(e) => setTanggalCair(e.target.value)}
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Metode Angsur">
              <Input
                value={metodeAngsur}
                onChange={(e) => setMetodeAngsur(e.target.value)}
                disabled={disabled}
                placeholder="Flat / Anuitas"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ROW 6 */}
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Pembayaran">
              <Input
                value={pembayaran}
                onChange={(e) => setPembayaran(e.target.value)}
                disabled={disabled}
                placeholder="Transfer / Cash / Auto Debit"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Denda (%)">
              <Input
                value={rateDenda}
                onChange={(e) => setRateDenda(e.target.value)}
                disabled={disabled}
                placeholder="Rate denda"
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="Penalty (%)">
              <Input
                value={penalty}
                onChange={(e) => setPenalty(e.target.value)}
                disabled={disabled}
                placeholder="Penalty pelunasan dipercepat"
              />
            </Form.Item>
          </Col>
        </Row>

        <div className="flex justify-end mb-4 gap-2">
          {!isEdit ? (
            <Button
              disabled={!initialData || isViewer}
              type="primary"
              onClick={() => setIsEdit(true)}
            >
              Edit
            </Button>
          ) : (
            <>
              <Button type="primary" loading={loading} disabled={isViewer} onClick={handleSave}>
                Simpan
              </Button>
              <Button onClick={handleCancel} disabled={disabled}>
                Batal
              </Button>
            </>
          )}
        </div>
        {/* <div className="flex justify-end mt-4">
          <Button
            type="primary"
            onClick={handleSave}
            loading={loading}
            disabled={disabled}
          >
            Simpan
          </Button>
        </div> */}
      </Form>
    </div>
  );
}
